import React from 'react';
import { Outlet } from 'react-router-dom';

import { usePrintMode } from '@hooks/use-print-mode';

interface ProposalLayoutProps {
  children?: React.ReactNode;
}

export const ProposalLayout: React.FC<ProposalLayoutProps> = ({ children }) => {
  const isPrintMode = usePrintMode();

  const content = children || <Outlet />;

  if (isPrintMode) return <>{content}</>;

  return <div className="h-screen w-full overflow-auto">{content}</div>;
};
